module.exports = __webpack_public_path__ + "public/SiteIcons/plusListing.svg?b90a5010";